import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import HomePage from "@/pages/HomePage";
import MarketingPage from "@/pages/MarketingPage";
import ProductionPage from "@/pages/ProductionPage";
import TrainingRecruitmentPage from "@/pages/TrainingRecruitmentPage";
import PortfolioPage from "@/pages/PortfolioPage";
import CoursesPage from "@/pages/CoursesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import InfluencersPage from "@/pages/InfluencersPage";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <SettingsProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/marketing" element={<MarketingPage />} />
              <Route path="/production" element={<ProductionPage />} />
              <Route path="/training" element={<TrainingRecruitmentPage />} />
              <Route path="/recruitment" element={<TrainingRecruitmentPage />} />
              <Route path="/training-recruitment" element={<TrainingRecruitmentPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/courses" element={<CoursesPage />} />
              <Route path="/influencers" element={<InfluencersPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
            </Route>
          </Routes>
          <WhatsAppButton />
        </SettingsProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
